import accountConstants from "components/Event/Accounts/constants";

export default function(fields) {
  const primaryFields = [accountConstants.name];
  return primaryFields
    .map(id => fields.find(field => field.id === id || field.is_primary_field))
    .filter(Boolean)[0];
}
